import type { ItemAttributes, ItemNames } from '@ps-smart-cp/ppfw-client';
import { Bool, Characters, ItemName, Locale, Numeric } from '@ps-smart-cp/ppfw-client';

interface Schema {
  // 物件番号・親の桁数
  articleNoParentDigits: string;

  // 物件番号・親のゼロ詰め
  isPaddingParentNoWithZero: boolean;

  // 物件番号・枝の最小値
  articleNoBranchMin: string;

  // 自動採番機能
  isAutoNumbering: boolean;
}

const attributes = {
  articleNoParentDigits: Numeric.of(1, 15, 0),
  isPaddingParentNoWithZero: Bool.new(),
  articleNoBranchMin: Characters.preset.numerical({ minLen: 3, maxLen: 3 }),
  isAutoNumbering: Bool.new(),
} satisfies ItemAttributes<Schema>;

const names = {
  articleNoParentDigits: ItemName.of(
    [Locale.ja, '物件番号・親の桁数'],
    [Locale.en, 'Article No Parent Digits'],
  ),
  isPaddingParentNoWithZero: ItemName.of(
    [Locale.ja, '物件番号・親のゼロ詰め'],
    [Locale.en, 'Zero Padding Article Parent No'],
  ),
  articleNoBranchMin: ItemName.of([Locale.ja, '物件番号・枝の最小値'], [Locale.en, 'Article No Branch Min']),
  isAutoNumbering: ItemName.of([Locale.ja, '自動採番機能'], [Locale.en, 'Auto Number Func']),
} satisfies ItemNames<Schema>;

interface Record {
  articleNoParentDigits: number;
  isPaddingParentNoWithZero: boolean;
  articleNoBranchMin: number;
  isAutoNumbering: boolean;
}

const articleManagement = {
  names,
  attributes,
};

interface ArticleManagement {
  schema: Schema;
  record: Record;
}

export { articleManagement };
export type { ArticleManagement };
